import { Snackbar, Icon, palette } from '@yuno/design-system-web'

import { Content, TitleTip } from './style'
import WrapperLayout from '../../layouts/wrapper-layout'

import {
  Wrapper,
  FIVE_SECONDS,
  TipWrapper,
  TextContent,
} from './api-keys.styled'
import { useApiKeys } from './use-api-keys'
import { useVerifyPermission } from '@yuno/dashboard-container-mfe'
import { PermissionsAvailable } from '@yuno/dashboard-authentication-mfe'
import TableResponsive from './components/table-responsive/table-responsive'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useGetOrganization } from '@yuno/dashboard-api-mfe'

const ApiKeysContainer = () => {
  const {
    onCopied,
    data,
    isLoading,
    showSnackbar,
    accountId,
    setShowSnackbar,
  } = useApiKeys()
  const { data: dataOrganizations } = useGetOrganization()
  const isAdmin = dataOrganizations?.type === 'ADMIN'

  const { allowed } = useVerifyPermission(
    PermissionsAvailable.VIEW_ACCOUNT_KEYS,
  )
  const { t } = useTranslation()
  const [snackBarMessage, setSnackBarMessage] = useState('')

  const columnsTable = [
    {
      label: t('name'),
    },
    {
      label: t('token'),
    },
    {
      label: t('actions'),
    },
  ]

  const rowsFirstCard = [
    { label: t('accountCode'), value: accountId || data?.x_account_code },
  ]
  const rowsSecondCard = [
    { label: t('publicApiKey'), value: data?.public_api_key },
    { label: t('privateSecrectKey'), value: data?.private_secret_key },
  ]

  return (
    <WrapperLayout>
      <Wrapper>
        <TableResponsive
          columnsTable={columnsTable}
          isLoading={isLoading}
          onCopied={onCopied}
          setMessageSnack={setSnackBarMessage}
          rows={rowsFirstCard}
          subtitle={t('tokenHasChanges')}
          title={t('accountKey')}
          withCopy={true}
          withShow={false}
        />
        <TableResponsive
          columnsTable={columnsTable}
          isLoading={isLoading}
          onCopied={onCopied}
          setMessageSnack={setSnackBarMessage}
          rows={rowsSecondCard}
          allowed={allowed}
          subtitle={t('treatLikePassword')}
          title={t('organizationKeys')}
          withCopy={true}
          withShow={true}
          needPassword={isAdmin}
        />
      </Wrapper>

      <TipWrapper>
        <Icon
          color={palette.grey[5]}
          name={'Lightbulb'}
          weight="fill"
          size="24px"
        />
        <TextContent>
          <TitleTip>{t('confirmChangeCredentials')}</TitleTip>
          <Content>
            {t('credentialsCompromised')}
            <span>{t('credentialsCompromisedEmail')}</span>
          </Content>
        </TextContent>
      </TipWrapper>

      <Snackbar
        open={showSnackbar}
        autoHideDuration={FIVE_SECONDS}
        onClose={() => setShowSnackbar(false)}
        message={snackBarMessage}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      />
    </WrapperLayout>
  )
}

export default ApiKeysContainer
